import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function Footer() {
  const { t } = useTranslation();
  const menuItems = useSelector((state) => state.menuReducer);
  const filterByLocation = (location) => {
    return menuItems?.data?.filter(item => item.location === location);
  };

  const selector = useSelector((state) => state.appearanceReducer );
  const appearanceData = selector?.data;

  // the admin copyright text carries a fixed year; always show the current one
  const year = new Date().getFullYear();
  const copyright = appearanceData?.footer_copyright_text
    ? appearanceData.footer_copyright_text.replace(/\b(19|20)\d{2}\b/, year)
    : t('footer.copyright', { year });


  return (
    <>
      <footer>
        <div className="footer-area pt-100">
          <div className="container">
            <div className="footer-main mb-56">
              <div className="row">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h5 className="footer-widget-title">{t('footer.about_us')}</h5>
                    <ul className="footer-widget-menu list-unstyled">
                      {filterByLocation('about').map((item) => (
                        item.type === 'url' ?
                        <li key={item.id}><a href={item?.url} target="_blank" rel="noopener noreferrer">{item.title}</a></li>
                        :
                        <li key={item.id}><Link to={`/page/${item.url}`}>{item.title}</Link></li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h5 className="footer-widget-title">{t('footer.for_students')}</h5>
                    <ul className="footer-widget-menu list-unstyled">
                    {filterByLocation('student').map((item) => (
                      item.type === 'url' ?
                      <li key={item.id}><a href={item?.url} target="_blank" rel="noopener noreferrer">{item.title}</a></li>
                      :
                      <li key={item.id}><Link to={`/page/${item.url}`}>{item.title}</Link></li>
                    ))}
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h5 className="footer-widget-title">{t('footer.for_tutors')}</h5>
                    <ul className="footer-widget-menu list-unstyled">
                    {filterByLocation('teacher').map((item) => (
                      item.type === 'url' ?
                      <li key={item.id}><a href={item?.url}>{item.title}</a></li>
                      :
                      <li key={item.id}><Link to={`/page/${item.url}`}>{item.title}</Link></li>
                    ))}
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h5 className="footer-widget-title">{t('footer.xller_career')}</h5>
                    <ul className="footer-widget-menu list-unstyled">
                    {filterByLocation('career').map((item) => (
                      item.type === 'url' ?
                      <li key={item.id}><a href={item?.url} target="_blank" rel="noopener noreferrer">{item.title}</a></li>
                      :
                      <li key={item.id}><Link to={`/page/${item.url}`}>{item.title}</Link></li>
                    ))}
                    </ul>
                  </div>
                </div>

              </div>
            </div>
            <div className="footer-main">
              <div className="row">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h5 className="footer-widget-title">{t('footer.contacts')}</h5>
                    <ul className="footer-widget-menu list-unstyled">
                      <li className="footer-contact">{appearanceData?.footer_contacts}</li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h5 className="footer-widget-title">{t('footer.support')}</h5>
                    <ul className="footer-widget-menu list-unstyled">
                    {filterByLocation('support').map((item) => (
                      item.type === 'url' ?
                      <li key={item.id}><a href={item?.url}>{item.title}</a></li>
                      :
                      <li key={item.id}><Link to={`/page/${item.url}`}>{item.title}</Link></li>
                    ))}
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <h5 className="footer-widget-title">{t('footer.xller_networks')}</h5>
                    <ul className="footer-widget-menu list-unstyled">
                    {filterByLocation('social').map((item) => (
                      item.type === 'url' ?
                        <li key={item.id}><a href={item?.url} target="_blank" rel="noopener noreferrer">{item.title}</a></li>
                        :
                        <li key={item.id}><Link to={`/page/${item.url}`}>{item.title}</Link></li>
                      ))}
                    </ul>
                  </div>
                </div>
                
              </div>
            </div>
            <div className="copyright-area">
              <div className="row">
                <p className="m-0">{copyright}</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}